import { Component, OnInit, ViewChild, ElementRef, TemplateRef } from '@angular/core'
import { sla, kpiRelease, quater, year, kpi, slaperformance, kpiViewDashBoard, performanceDashBoard, filecontent } from './../../../../models/slakpi';
import { division, tenant } from './../../../../models/admin';
import { UtilityService } from './../../../../services/utility.service';
import { SLAKPIApiService } from './../../../../services/slakpi.service';
import { AdminApiService } from './../../../../services/admin.service';
import { UserService } from './../../../../services/user.service';
import { SpinnerVisibilityService } from 'ng-http-loader';
import { GoogleChartComponent } from 'ng2-google-charts';
declare var jquery: any;
declare var $: any;
declare var google: any;
import { Router, ActivatedRoute, Params } from '@angular/router';
import { KPIAllHistoryComponent } from './../../../../component/slakpi/kpi-allhistory/kpi-allhistory.component';
import { uniqBy } from 'lodash';
import {
  AngularGridInstance,
  Column,
  FieldType,
  Filters,
  Formatter,
  GridOption,
  FileType,
  Formatters,
  OnEventArgs,

} from 'angular-slickgrid';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { ToasterService } from '../../../../toaster.service';
import { RSAHelper } from '../../../../models/RSAHelper';
@Component({
  selector: 'app-slaperformance.component',
  templateUrl: './slaperformance.component.html',
  styleUrls: ['./slaperformance.component.css']

})
export class SLAPerformanceNewComponent implements OnInit {
  public sli_data: any;
  public slaPerformance_data: any;
  public yearData: any;
  public quaterData: any;
  public division_data: any=[];
  public frequency_data: any;
  public resettype_data: any;
  public slaUno?: any=0;
  public yearUno?: any=0;
  public quarterUno?: any=0;
  public divisionUno?: any=0;
  public frequencyUno?: any=0;  
  public objkpiRelease: kpiRelease;
  public isback: boolean = false;
  columnDefinitions: Column[];
  gridOptions: GridOption;
  public loading: boolean = true;
  angularGrid: AngularGridInstance;
  dataset: any;
  public isStart: boolean = true;
  user: any = {};
  login_UserID: string; // number
  currentYear?: number;
  currentHalf?: number;
  currentQuarter?: number;
  currentMonth?: number;
  wellperformKPIRange?: number;
  isToggle: boolean = false;

  //for Users Permission
  public permision_add: boolean = false;
  public permision_edit: boolean = false;
  public permision_delete: boolean = false;

  isAdmin: boolean = false;

  public Qyearsla: number = 0;
  public Qquatersla: number = 0;
  public Qdivisionsla: number = 0;
  public QPerformance: number = 0;

  //for KPI All Hisory Dialog

  public kpiUnoSelected: number = 0;
  public kpinameSelected: string = '';

  //@ViewChild('KPIAllHistoryDialog', { static: false }) KPIAllHistoryDialog: DialogComponent;
  public position_history: object = { X: 70, Y: 100 };
  public searchText: string;
  public dataSearch: any[];
  public noDataImg: any;
  public tenantUno: any;
  public isDigitalDewa: boolean=false;
  public slaPerformanceDashboard_data: any;
  public wellPerformedSLACount: number=0;
  public underPerformedSLACount: number=0;
  public SLACount: number=0;
  public reportedSLACount: number=0;
  public totalSLAAverage: number=0;
  public SlaChartOptionchart:any= { };
  public welformedchartOption: any = {};

  public slaPerformanceFilter: any = {};
  public chartValue: string = 'Quarter';
  public chartType_data: any;
    AttachmentList: any=[];
  fileItemCount: number = 0;
  modalRef: any;
  isSingleClick: Boolean = true;
  @ViewChild('attachmentTemplate', { static: false }) attachmentTemplate: TemplateRef<any>;
    selectedSLAUno: string;
  g_previousIndex: any;

  slaName: string = '';
  divisionPlaceholder: string = 'Division';
    isDivision: number =1;
  constructor(public restApi: SLAKPIApiService, private _activatedRoute: ActivatedRoute,
    public adminService: AdminApiService, private userService: UserService,
    public utilityService: UtilityService, private router: Router, private toaster: ToasterService, private spinner: SpinnerVisibilityService, private kpiAllHistoryComponent: KPIAllHistoryComponent, private modalService: BsModalService, public RASHelper: RSAHelper) {

    this._activatedRoute.queryParams.subscribe((params: Params) => {
      
      this.Qyearsla = Number(params['yearsla']);
      this.Qquatersla = Number(params['quatersla']);
      this.Qdivisionsla = Number(params['divisionsla']);
      this.QPerformance = (params['performance']!=undefined) ? Number(params['performance']) : 0;
      if (this.Qyearsla > 0) this.isback = true;
       
    });
    
    //To Validate User Permission
    this.user = this.userService.getUserInfo();

    this.slaPerformanceFilter = this.userService.getSLAFilterInfo();
    this.login_UserID = this.user.id;
    this.noDataImg = this.utilityService.getnodataImage();
    this.tenantUno = this.user.tenantUno;
    this.isDigitalDewa = (this.user.tenantDigitalUser == 'true') ? true : false;
    this.isAdmin = (this.user.role == 'Administrator') ? true : false;
    if (!this.isAdmin) {
      this.CheckUserPermission();
    }
    else {
      this.permision_add = true;
      this.permision_edit = true;
      this.permision_delete = true;
      
    }

  }
  ngOnInit() {
    this.userService.CheckLogin();
    this.gridOptions = {
      autoHeight: true,
      enableAutoResize: true,
      enablePagination: true,
      pagination: {
        pageSizes: [5, 10, 20, 50, 100, 500],
        pageSize: 100
      },
      enableFiltering: true,
      alwaysShowVerticalScroll: false,
      enableRowSelection: true,
      autoResize: {
        containerId: 'musherat-grid',
        delay: 0,
        sidePadding: 10,
        bottomPadding: 10
      },
      enableExcelExport: true,
      enableExcelCopyBuffer: true,
      enableFilterTrimWhiteSpace: true,
      showCustomFooter: true, // display some metrics in the bottom custom footer
      enableContextMenu: true,
      enableCellMenu: true,
      forceFitColumns: true,

    };
    this.user = this.userService.getUserInfo();
    this.login_UserID = this.user.id;
    this.slaName = this.user.slaname;
    if (this.tenantUno > 1) { this.divisionPlaceholder = "Select" }
    this.currentYear = this.user.currentYear;
    this.currentHalf = this.user.currentHalf;
    this.currentQuarter = this.user.currentQuarter;
    this.currentMonth = this.user.currentMonth;
    this.wellperformKPIRange = this.user.wellperformKPIRange;
    this.yearUno = this.currentYear;
    this.quarterUno = this.currentQuarter;
    this.objkpiRelease = new kpiRelease();
    //Load Default filter values
    this.getTenantInfo();
    this.getChartTypeData();
    this.loadFilterValues();
    this.loadFrequency();
    
   
  }
  //Load Frequency Values
  loadFilterValues() {
    this.spinner.show();
    let inpValue = new year();
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 1;
    inpValue.tenantUno = this.tenantUno;
    inpValue.userUno = this.login_UserID;
    this.isStart = true;
    this.restApi.getKPITranFilterValues(inpValue)
      .subscribe(data => {
        
        let objdata: any = data;
        this.sli_data = objdata.list_SLAMaster;
        this.division_data = objdata.list_DivisionMaster;
        this.quaterData = objdata.list_QuarterMaster;
        this.yearData = objdata.list_YearMaster;

        setTimeout(() => {
          //if (this.division_data != null && this.division_data.length == 1) {
          //  this.divisionUno = this.division_data[0].divisionUno;
          //}


          this.yearUno = (this.Qyearsla > 0) ? this.Qyearsla : Number(this.yearUno);
          //this.yearUno = (this.Qyearsla > 0) ? this.Qyearsla : Number(this.yearUno);
          this.quarterUno = (this.Qquatersla > 0) ? this.Qquatersla : Number(this.quarterUno);
          if (this.Qdivisionsla > 0)
            this.divisionUno = (this.Qdivisionsla > 0) ? this.Qdivisionsla : Number(this.Qdivisionsla);
          
            if (this.slaPerformanceFilter != undefined) {

              this.yearUno = parseInt(this.slaPerformanceFilter.yearUno);
              this.quarterUno = parseInt(this.slaPerformanceFilter.quarterUno);
              this.divisionUno = parseInt(this.slaPerformanceFilter.divisionUno);
            }
          

          this.loadSlaPerformance(2); //by filter
          this.loadPerformanceDashBoard();
        }, 30);

        this.spinner.hide();
      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        this.spinner.hide();
      });

  }
  //To Validate Current User - Page Level Permission
  CheckUserPermission() {

    
    this.permision_add = true;
    this.permision_edit = true;
    this.permision_delete = true;
  }

   

 
  loadFrequency() {
    
    if (this.isDigitalDewa == false) {
      this.frequency_data = [];
      this.frequency_data = [
        { frequencyCode: 1, frequencyName: 'Yearly' },
        { frequencyCode: 2, frequencyName: 'Semi-annually' },
        { frequencyCode: 3, frequencyName: 'Quarterly' }
        //{ frequencyCode: 4, frequencyName: 'Monthly' }
      ];
    }

    if (this.isDigitalDewa == true || this.tenantUno == 5) {
      this.frequency_data = [];
      this.frequency_data = [
        { frequencyCode: 1, frequencyName: 'Yearly' },
        { frequencyCode: 2, frequencyName: 'Semi-annually' },
        { frequencyCode: 3, frequencyName: 'Quarterly' },
        { frequencyCode: 4, frequencyName: 'Monthly' }
      ];
    }
  }
  

  // Get SlaPerformance list
  loadSlaPerformance(condition) {
    
    this.loading = true;
    this.spinner.show();
    let inpValue = new slaperformance();
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = condition;
    inpValue.tenantUno = this.tenantUno;
    inpValue.userUno = this.login_UserID;
    inpValue.slaUno = (this.slaUno == 0 || this.slaUno == undefined) ? 0 :this.slaUno;
    inpValue.kpiyear = (this.yearUno == 0 || this.yearUno == undefined) ? 0 : this.yearUno;
    inpValue.kpiquarter = (this.quarterUno == 0 || this.quarterUno == undefined) ? 0 : this.quarterUno;
    inpValue.divisionUno = (this.divisionUno == 0 || this.divisionUno == undefined) ? 0 :this.divisionUno;
    inpValue.frequencyUno = (this.frequencyUno == 0 || this.frequencyUno == undefined) ? 0 :this.frequencyUno;
    inpValue.half = this.currentHalf;
    inpValue.month = this.currentMonth;
    inpValue.wellperformKPIRange = this.wellperformKPIRange;
    
    this.restApi.getSlaPerformance(inpValue)
      .subscribe(data => {
        
       
        if (this.QPerformance > 0) {
          let objdata: any = data;
          this.slaPerformance_data = objdata.filter(s => s.bandValue == this.QPerformance);
        }
        else {
          this.slaPerformance_data = data;
        }
        const mockDataset = [];
        for (let i = 0; i < this.slaPerformance_data.length; i++) {

          let reporting = (this.slaPerformance_data[i].reporting != null && this.slaPerformance_data[i].reporting != '') ? this.slaPerformance_data[i].reporting : '0';
          let noOfEvaluatedKPI = (this.slaPerformance_data[i].noOfEvaluatedKPI != null && this.slaPerformance_data[i].noOfEvaluatedKPI != '') ? this.slaPerformance_data[i].noOfEvaluatedKPI : '0';
          let noOfKPI = (this.slaPerformance_data[i].noOfKPI != null && this.slaPerformance_data[i].noOfKPI != '') ? this.slaPerformance_data[i].noOfKPI : '0';

          let wellPerformedKPI = (this.slaPerformance_data[i].wellPerformedKPI != null && this.slaPerformance_data[i].wellPerformedKPI != '') ? this.slaPerformance_data[i].wellPerformedKPI : '0';

          //let reportingPercentage = Math.round((parseInt(reporting) / (parseInt(noOfKPI))) * 100);
          

          let noOfKPIReleased = (this.slaPerformance_data[i].noOfKPIReleased != null && this.slaPerformance_data[i].noOfKPIReleased != '') ? this.slaPerformance_data[i].noOfKPIReleased : '0';


          let reportingPercentage = Math.round((parseInt(noOfEvaluatedKPI) / (parseInt(noOfKPIReleased))) * 100);

          let wpKPIPercentage = Math.round((parseInt(wellPerformedKPI) / (parseInt(noOfKPIReleased))) * 100);

          


          mockDataset[i] = {
            id: i + 1,
            slaUno: this.slaPerformance_data[i].slaUno,
            slaName: this.slaPerformance_data[i].slaName,
            year: this.slaPerformance_data[i].year,
            quarter: this.slaPerformance_data[i].quarter,
            slaPerfomancePercentage: this.slaPerformance_data[i].bandValue==0?'-': this.slaPerformance_data[i].slaPerfomancePercentage +'%',
            bandValueText: this.slaPerformance_data[i].bandValueText,
            bandValue: this.slaPerformance_data[i].bandValue,
            noOfKPI: noOfKPI,
            noOfEvaluatedKPI: noOfEvaluatedKPI,
            reporting: (reportingPercentage==0)?'-':reportingPercentage + ' %',
            wpKPIPercentage: wpKPIPercentage + ' %',
            noOfKPIReleased: noOfKPIReleased
          };
        }
        this.dataset = mockDataset;
        this.dataSearch = mockDataset;


        

        if (mockDataset.length > 0) {
          this.setColnDefn();
        }
       

        setTimeout(() => {
          this.loading = false;
          this.spinner.hide();
        }, 500);
      },
        (error) => {
          //Called when error
          this.spinner.hide();
          this.isStart = false;
          this.loading = false;
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
       // this.spinner.hide();
        //this.isStart = false;
      });
  }

  viewKPIHistoryAll(kpiUno: any, kpiNameEn: any) {
    this.kpiUnoSelected = kpiUno;
    this.kpinameSelected = kpiNameEn;
    this.kpiAllHistoryComponent.viewKPI(kpiUno);
    //this.KPIAllHistoryDialog.show();

  }

  angularGridReady(angularGrid: AngularGridInstance) {
    this.angularGrid = angularGrid;
    this.userService.angularGrid = angularGrid;
  }

  drawertoggle() {
    
    this.isToggle = (this.isToggle) ? false : true;
  }

  // Choose city using select dropdown
  onchangeSLA(e) {
    
    //alert(e.itemData.slaUno);
    this.slaUno = (e.length == 0 || e[0].value == 'All') ? 0 : e[0].value;
    if (!this.isStart) {
      this.onSelectedTab();
    }

  }

  onchangeChart(e) {
    

    this.chartValue = (e && e.length > 0) ? e[0].value : 'Quarter';
    if (!this.isStart) {

      this.loadPerformanceDashBoard();
    }
  }

  onchangeYear(e) {
    
    this.yearUno = ( e.length == 0 || e[0].value == 'All') ? 0 : e[0].value;
    if (!this.isStart) {
      this.onSelectedTab();
    }
  }


  onchangeQuarter(e) {
    this.quarterUno = (e.length == 0 || e[0].value == 'All') ? 0 : e[0].value;
    if (!this.isStart) {
      this.onSelectedTab();
    }
  }


  onchangeDivision(e) {
    this.divisionUno = (e.length == 0 || e[0].value == 'All') ? 0 : e[0].value;
    if (!this.isStart) {
      this.onSelectedTab();
    }
  }


  onchangeFrequency(e) {
    this.frequencyUno = (e && e.length > 0 && e[0].value == 'All') ? 0 : e[0].value;
    if (!this.isStart) {
      this.onSelectedTab();
    }
  }

  
  onSelectedTab() {   
    this.loadSlaPerformance(2); //by filter
    this.loadPerformanceDashBoard();
  }


  uniqueArray(arrayList, val, label) {
    var temp = this;
    var aList = [];
    if (arrayList) {
      for (var i = 0, l = arrayList.length; i < l; i++)
        if (aList.filter(item => item.label == temp.Checklabel(arrayList[i][label])).length == 0) {

          aList.push({
            'value': this.CheckValue(arrayList[i][val]), 'label': this.Checklabel(arrayList[i][label])
          });
        }
    }


    aList.sort((a: any, b: any) => {
      if (a['value'] < b['value']) {
        return -1;
      } else if (a['value'] > b['value']) {
        return 1;
      } else {
        return 0;
      }
    });
    return aList;
  }

  exportToExcel() {
    var temp = this;
    setTimeout(function () {
      temp.angularGrid.excelExportService.exportToExcel({
        filename: 'Export',
        format: FileType.xlsx,

      });
    }, 100)


  }


  Checklabel(val) {
    if (val != undefined && val != null && val != '' && val != ' ')
      return val.trim();
    else
      return ''

  }

  CheckValue(val) {
    if (val != undefined && val != null && val != '' && val != ':')
      return val;
    else
      return ' '

  }

  IsNull(val) {
    if (val != undefined && val != null && val != '') {
      val = val.trim()
      return val.charAt(0).toUpperCase() + val.slice(1);
    }
    else
      return ' '

  }
  searchGrid() {
    
    if (this.searchText != "") {
      this.dataset = this.dataSearch.filter(a =>
        a.slaName && a.slaName.toLowerCase().includes(this.searchText.toLowerCase())
        || (a.year && a.year.toLowerCase().includes(this.searchText.toLowerCase()))
        || (a.quarter && a.quarter.toLowerCase().includes(this.searchText.toLowerCase()))
        || (a.slaPerfomancePercentage && a.slaPerfomancePercentage.toLowerCase().includes(this.searchText.toLowerCase()))
        || (a.bandValueText && a.bandValueText.toLowerCase().includes(this.searchText.toLowerCase())));
    }
    else
      this.dataset = this.dataSearch;
  }
  setColnDefn() {
    let temp = this;
    this.columnDefinitions = [
      {
        id: 'slaName', name: this.slaName, field: 'slaName', sortable: true, width: 100,
        type: FieldType.string, filterable: true,
        filter: {
          collection: this.uniqueArray(this.dataset, 'slaName', 'slaName'),
          model: Filters.multipleSelect,
        }
      },
      {
        id: 'noOfKPI', name: 'Number of KPIs', field: 'noOfKPI', sortable: true,
        type: FieldType.string, filterable: true,
        filter: {
          collection: this.uniqueArray(this.dataset, 'noOfKPI', 'noOfKPI'),
          model: Filters.multipleSelect,
        }
      },
      {
        id: 'noOfKPIReleased', name: 'Number of Released KPIs', field: 'noOfKPIReleased', sortable: true,
        type: FieldType.string, filterable: true,
        filter: {
          collection: this.uniqueArray(this.dataset, 'noOfKPIReleased', 'noOfKPIReleased'),
          model: Filters.multipleSelect,
        }
      },
      
      {
        id: 'noOfEvaluatedKPI', name: 'Number of Evaluated KPIs', field: 'noOfEvaluatedKPI', sortable: true, 
        type: FieldType.string, filterable: true,
        filter: {
          collection: this.uniqueArray(this.dataset, 'noOfEvaluatedKPI', 'noOfEvaluatedKPI'),
          model: Filters.multipleSelect,
        }
      },
      {
        id: 'reporting', name: 'Reporting %', field: 'reporting', sortable: true, type: FieldType.string, filterable: true,
        filter: {
          collection: this.uniqueArray(this.dataset, 'reporting', 'reporting'),
          model: Filters.multipleSelect,
        }
      },
      {
        id: 'slaPerfomancePercentage', name: '% of Well-Performing KPIs', field: 'slaPerfomancePercentage', sortable: true,
        type: FieldType.string, filterable: true,
        filter: {
          collection: this.uniqueArray(this.dataset, 'slaPerfomancePercentage', 'slaPerfomancePercentage'),
          model: Filters.multipleSelect,
        }
      },

      //{
      //  id: 'year', name: 'Year', field: 'year', sortable: true, type: FieldType.string, filterable: true,
      //  filter: {
      //    collection: this.uniqueArray(this.dataset, 'year', 'year'),
      //    model: Filters.multipleSelect,

      //  }
      //},
      //{
      //  id: 'quarter', name: 'Quarter', field: 'quarter', sortable: true, type: FieldType.string, filterable: true,
      //  filter: {
      //    collection: this.uniqueArray(this.dataset, 'quarter', 'quarter'),
      //    model: Filters.multipleSelect,
      //  }
      //},
     
      {
        id: 'bandValueText', name: 'Performance', field: 'bandValueText', selectable: false, type: FieldType.string, filterable: true, formatter: this.bandFormatter,
        filter: {
          collection: this.uniqueArray(this.dataset, 'bandValueText', 'bandValueText'),
          model: Filters.multipleSelect,
        }
      },
      {
        id: 'action', name: 'Action', field: 'action', cssClass: 'blue', width: 50,
        excludeFromExport: true,
        formatter: this.actionFormatter,
        cellMenu: {
          hideCloseButton: false,
          commandTitleKey: 'COMMANDS',
          commandItems: [
            {
              command: 'edit-row', titleKey: 'EDIT_ROW', positionOrder: 62, title: 'View',
              iconCssClass: 'fa fa-line-chart', cssClass: 'blue', textCssClass: 'bold',
              action: (e, args) => {
                let rdata: any = args.dataContext;

                this.yearUno = this.yearUno ? this.yearUno : 0;
                this.quarterUno = this.quarterUno ? this.quarterUno : 0;
                this.divisionUno = this.divisionUno ? this.divisionUno : 0;

                localStorage.removeItem('SlaPeformanceFilter');
                localStorage.setItem('SlaPeformanceFilter', '{"yearUno":"' + this.yearUno + '","quarterUno":"' + this.quarterUno + '","divisionUno":"' + this.divisionUno + '"}');

                this.router.navigate(['/dashboard-slaperformance-view/' + rdata.slaUno], { queryParams: { yearsla: this.yearUno, quatersla: this.quarterUno, divisionsla: this.divisionUno } });

                
                
              },
              // only show command to 'Delete Row' when the task is not completed

            },

            
            {
              command: 'attachment-row', titleKey: 'VIEW_ROW', positionOrder: 63, title: 'Attachment',
              iconCssClass: 'fa fa-files-o', cssClass: 'blue', textCssClass: 'bold',
              action: (e, args) => {
                
                  let rdata: any = args.dataContext;
                  if (rdata.attachmentCount < 1) {
                    // Swal.fire('Error', 'No Data Available', 'info');
                    this.toaster.show('error', 'Error', 'No Data Available');
                    return;
                  }
                this.selectedSLAUno = rdata.slaUno;
                this.getFiles(rdata.slaUno)
                  this.modalRef = this.modalService.show(
                    this.attachmentTemplate,
                    Object.assign({}, {
                      class: 'gray modal-lg',
                      backdrop: true,
                      keyboard: true,
                      focus: true,
                      show: false,
                      ignoreBackdropClick: true,
                      animated: true
                    })
                  );
                
              },
              // only show command to 'Delete Row' when the task is not completed

            }


          ],
        }
      }
      //{
      //  id: 'action', name: 'Action', field: 'action', width: 50, cssClass: 'blue',
      //  type: FieldType.string, formatter: (row, cell, val, columnDef, data) => { return '<span style="cursor:pointer"><i class="fa fa-line-chart fa-lg"></i></span>'; },
      //  onCellClick: (e: Event, args: OnEventArgs) => {
      //    let rdata: any = args.dataContext;
         
      //    this.yearUno = this.yearUno ? this.yearUno : 0;
      //    this.quarterUno = this.quarterUno ? this.quarterUno : 0;
      //    this.divisionUno = this.divisionUno ? this.divisionUno : 0;
          
      //    localStorage.removeItem('SlaPeformanceFilter');
      //    localStorage.setItem('SlaPeformanceFilter', '{"yearUno":"' + this.yearUno + '","quarterUno":"' + this.quarterUno + '","divisionUno":"' + this.divisionUno + '"}');

      //    this.router.navigate(['/dashboard-slaperformance-view/' + rdata.slaUno], { queryParams: { yearsla: this.yearUno, quatersla: this.quarterUno, divisionsla: this.divisionUno } });
      //  }
      //}
    ]


  }

  bandFormatter: Formatter = (row, cell, value, columnDef, dataContext) => {
    if (dataContext.bandValue == '1')
      return `<div class="bg-grey-progress" > <span class="green-bar"></span></div>`;
    if (dataContext.bandValue == '2')
      return `<div class="bg-grey-progress" > <span class="red-bar"></span></div>`;
    if (dataContext.bandValue != 1 && dataContext.bandValue != 2 && dataContext.bandValue == 0)
      return `<div class="bg-grey-progress" > <span class="bluedark-bar"></span></div>`;
  };
 
  actionFormatter: Formatter = (row, cell, value, columnDef, dataContext) => {
    return `<div class="fake-hyperlink"> <i class="fa fa-ellipsis-h fa-lg"></i></div>`;
  };
  getFiles(slaUno: string) {
    this.AttachmentList = null;
    let inpValue = new filecontent();
    inpValue.masterUNo = slaUno;
    inpValue.itemUNo = '0';
    inpValue.userUno = this.login_UserID;
    this.spinner.show();
    //this.slaUno = slaUno;
    
    this.restApi.SLA_FileSelect(inpValue)
      .subscribe(data => {
        
        this.AttachmentList = data;
        this.fileItemCount = (this.AttachmentList != undefined && this.AttachmentList != null) ? this.AttachmentList.length : 0;
        this.spinner.hide();

      },
        (error) => {
          this.spinner.hide();
        }
      ).add(() => {
        this.spinner.hide();
      });
  }
  backClick() {
    this.router.navigate(['/sladashboard/general'], { queryParams: { yearsla: this.yearUno, quatersla: this.quarterUno } });

  }

  loadPerformanceDashBoard() {

    
    let inpValue = new performanceDashBoard();
    inpValue.userUno = this.login_UserID;
    inpValue.languageUno = 1033;
    inpValue.condition = 1;
    inpValue.tenantUno = this.tenantUno;
    

    inpValue.slaUno = (this.slaUno == 0 || this.slaUno == undefined) ? 0 : this.slaUno;
    inpValue.currentYear = (this.yearUno == 0 || this.yearUno == undefined) ? 0 : this.yearUno;
    inpValue.currentQuarter = (this.quarterUno == 0 || this.quarterUno == undefined) ? 0 : this.quarterUno;
    inpValue.divisionUno = (this.divisionUno == 0 || this.divisionUno == undefined) ? 0 : this.divisionUno;
    inpValue.frequencyUno = (this.frequencyUno == 0 || this.frequencyUno == undefined) ? 0 : this.frequencyUno;
    inpValue.currentHalf = this.currentHalf;
    inpValue.currentMonth = this.currentMonth;

    inpValue.dashboardType = this.chartValue;
    inpValue.pageType = 'slahome';
    //inpValue.wellperformKPIRange = this.wellperformKPIRange;
    
    this.restApi.getPerformanceDashboard(inpValue)
      .subscribe(data => {
        

        this.slaPerformanceDashboard_data = data[0];

        this.wellPerformedSLACount = this.slaPerformanceDashboard_data.noOfWellPerformedSLACount;
        this.underPerformedSLACount = this.slaPerformanceDashboard_data.noOfUnderPerformedSLACount;
        this.SLACount = this.slaPerformanceDashboard_data.noOfSLACount;
        this.reportedSLACount = this.slaPerformanceDashboard_data.noOfReportedSLACount;


        //let wellPerformedSLAList = this.dataset.filter(a => a.bandValue == 1);
        //let notwellPerformedSLAList = this.dataset.filter(a => a.bandValue == 2);

        //this.wellPerformedSLACount = wellPerformedSLAList.length;
        //this.underPerformedSLACount = notwellPerformedSLAList.length;

        this.totalSLAAverage = (this.wellPerformedSLACount / (this.wellPerformedSLACount + this.underPerformedSLACount)) * 100;
        this.totalSLAAverage = this.RoundNum((isNaN(this.totalSLAAverage) || Number.isNaN(this.totalSLAAverage) || this.totalSLAAverage <= 0) ? 0 : parseFloat(this.totalSLAAverage.toFixed()), 0);


        this.spinner.show();
        setTimeout(() => {
          //google.charts.load('current', { 'packages': ['corechart'] });
          this.drawSlaChart(this.slaPerformanceDashboard_data);
          this.spinner.hide();
        }, 300);

        //this.totalSLAAverage = (this.wellPerformedSLACount / (this.wellPerformedSLACount + this.underPerformedSLACount)) * 100;
        //this.totalSLAAverage = this.RoundNum((isNaN(this.totalSLAAverage) || this.totalSLAAverage == NaN || this.totalSLAAverage <= 0) ? 0 : parseFloat(this.totalSLAAverage.toFixed()), 0);

        
        //if (this.slaPerformanceDashboard_data.list_SLAWPChartList > 0) {
        setTimeout(() => {
         
         //google.charts.load('current', { 'packages': ['corechart'] });
         this.welformedChart(this.slaPerformanceDashboard_data.list_SLAWPChartList);

          this.isStart = false;
          this.spinner.hide();
        }, 600);
      //}


      },
        (error) => {
          //Called when error
          this.isStart = false;
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        this.isStart = false;
      });
  }

  drawSlaChart = (option_data: any) => {

    //let tempArray = [['SLA', 'Count']];
   
    //tempArray.push(['Well Performed', '50']);
    //tempArray.push(['Not Well Performed', '50']);
   // var data = google.visualization.arrayToDataTable(tempArray);
    //const data = google.visualization.arrayToDataTable([
    //  ['Performance', 'Types of Reports Submitted'],
    //  ['Well Performed', this.wellPerformedSLACount],
    //  ['Not Well Performed', this.underPerformedSLACount],
    //]);
    //const options = {
    //  //title: 'Types of Reports Submitted',
    //  colors: ['#68b097', '#bcbcbc'],
    //  legend: { position: 'none' },
    //  chartArea: { left: 10, right: 10, top: 0, bottom: 0, width: "100%", height: "100%" },
    //  fontSize: 15
    //};

    //const chart = new google.visualization.PieChart(document.getElementById('SLA_Chart'));
    //chart.draw(data, options);
    let tempArray = [];

    let wellPerformedPercentage = (this.wellPerformedSLACount / (this.wellPerformedSLACount + this.underPerformedSLACount)) * 100;
    wellPerformedPercentage = this.RoundNum((isNaN(wellPerformedPercentage) || Number.isNaN(wellPerformedPercentage) || wellPerformedPercentage <= 0) ? 0 : parseFloat(wellPerformedPercentage.toFixed()), 0);

    let underPerformedPercentage = (this.underPerformedSLACount / (this.wellPerformedSLACount + this.underPerformedSLACount)) * 100;
    underPerformedPercentage = this.RoundNum((isNaN(underPerformedPercentage) || Number.isNaN(underPerformedPercentage) || underPerformedPercentage <= 0) ? 0 : parseFloat(underPerformedPercentage.toFixed()), 0);

    tempArray.push({ name: 'Well Performed', value: wellPerformedPercentage });
    if (this.underPerformedSLACount >0)
      tempArray.push({ name: 'Not Well Performed', value: underPerformedPercentage });
    //echarts starts
    this.SlaChartOptionchart = {
      tooltip: {
        trigger: "item",
        formatter: "{c}",
        textStyle: {
          fontWeight: "bold",
          fontSize: 13
        }
      },

      legend: {
        show: false,
        type: 'scroll',
        //orient: 'vertical',
        //right: 0,
        //top: 0,
        //bottom: 20,
        //pageIconColor: '#087b36',
        //pageIconInactiveColor: '#999999'
      },
      color: ['#68b097', '#bcbcbc'],

      series: [
        {
          name: '',
          type: 'pie',
          //radius: ['30%', '80%'],
          center: ["50%", "50%"],
          avoidLabelOverlap: false,
          label: {
            show: true,
            position: 'inside',
            color: '#fff',
            fontSize: '12',
            formatter: function (d) {
              return d.value + "%";
            }
          },
          emphasis: {
            label: {
              show: true,
              fontSize: '10',
              fontWeight: 'bold'
            }
          },
          labelLine: {
            show: true
          },

          data: tempArray
        }
      ]
    };
    // echarts ends
  }
  welformedChart = (option_data: any) => {
    
    let tempArray_XAxis = [];
    let tempArray_Count = [];
    let tempArray_target = [];

    for (var i = 0; i < option_data.length; i++) {
      let kpiYearName = option_data[i].year;
      let totalCount = option_data[i].totalCount;
      let targetValue = Math.round(option_data[i].targetValue);

      tempArray_XAxis.push(kpiYearName);
      tempArray_target.push(targetValue);
      tempArray_Count.push(totalCount);
      
      // tempArray.push([option_data[i].year, parseInt(option_data[i].totalCount)]);
    }
    if (this.tenantUno == 1) {
      this.welformedchartOption = {
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          //data: ['DEWA Actual', 'DEWA Target'],
          data: ['DEWA Actual'],
          bottom: '-20',
          left: 'center',
          //padding: [
          //  20,  // up
          //  0, // right
          //  0,  // down
          //  0, // left
          //],
        },

        color: ['#68b097', '#9e9e9e'],
        toolbox: {
          show: true,
          feature: {
            //dataView: { show: true, readOnly: false },
            //magicType: { show: true, type: ['line', 'bar'] },
            //restore: { show: true },
            //saveAsImage: { show: true }
          }
        },
        calculable: true,
        xAxis: [
          {
            type: 'category',
            data: tempArray_XAxis
          }
        ],
        yAxis: [
          {
            type: 'value'
          }
        ],
        grid: {
          left: '0',
          top: '10%',
          right: '0',
          bottom: '10%',
          containLabel: true
        },
        dataZoom: [
          {
            show: true,
            start: 1,
            end: 100,
            right: '2%',
            left: '5%',
            top: '75%',
            fillerColor: 'rgba(255, 255, 255, 0)',
            borderColor: '#fff',
            //backgroundColor: 'rgba(255, 255, 255, 1)',
            dataBackground: {
              areaStyle: {
                color: 'rgba(255, 255, 255, 1)',
              }
            },
            showDataShadow: false,
            showDetail: false,
            //zoomSelectionColor: '#fff',
            moveHandleSize: 1.
          }


        ],
        series: [
          {
            name: 'DEWA Actual',
            type: 'bar',
            data: tempArray_Count,
            barWidth: "5%",

          },
          //{
          //  name: 'DEWA Target',
          //  type: 'bar',
          //  data: tempArray_target,
          //  barWidth: "5%",


          //}
        ]
      };

    } else {

      this.welformedchartOption = {
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          data: ['DEWA Actual', 'DEWA Target'],
          //data: ['DEWA Actual'],
          bottom: '-20',
          left: 'center',
          //padding: [
          //  20,  // up
          //  0, // right
          //  0,  // down
          //  0, // left
          //],
        },

        color: ['#68b097', '#9e9e9e'],
        toolbox: {
          show: true,
          feature: {
            //dataView: { show: true, readOnly: false },
            //magicType: { show: true, type: ['line', 'bar'] },
            //restore: { show: true },
            //saveAsImage: { show: true }
          }
        },
        calculable: true,
        xAxis: [
          {
            type: 'category',
            data: tempArray_XAxis
          }
        ],
        yAxis: [
          {
            type: 'value'
          }
        ],
        grid: {
          left: '0',
          top: '10%',
          right: '0',
          bottom: '10%',
          containLabel: true
        },
        dataZoom: [
          {
            show: true,
            start: 1,
            end: 100,
            right: '2%',
            left: '5%',
            top: '75%',
            fillerColor: 'rgba(255, 255, 255, 0)',
            borderColor: '#fff',
            //backgroundColor: 'rgba(255, 255, 255, 1)',
            dataBackground: {
              areaStyle: {
                color: 'rgba(255, 255, 255, 1)',
              }
            },
            showDataShadow: false,
            showDetail: false,
            //zoomSelectionColor: '#fff',
            moveHandleSize: 1.
          },


        ],
        series: [
          {
            name: 'DEWA Actual',
            type: 'bar',
            data: tempArray_Count,
            barWidth: "5%",

          },
          {
            name: 'DEWA Target',
            type: 'bar',
            data: tempArray_target,
            barWidth: "5%",


          }
        ]
      };
    }
    //let tempArray = [['Quarter', 'TotalCount']];
    //for (var i = 0; i < option_data.length; i++) {
      
    //  tempArray.push([option_data[i].year, parseInt(option_data[i].totalCount)]);

    //}

    //

    //var data = new google.visualization.arrayToDataTable(tempArray);

    ////var data = google.visualization.arrayToDataTable([
    ////  ['Quarter', 'Target'],
    ////  ['2021/Q1',  70],
    ////  ['2021/Q2',  90],
    ////  ['2021/Q3',  60]
    ////]);
    

    //var options = {
    //  //title: 'Monthly Coffee Production by Country',
    //  colors: ['#45b664', '#0b937e'],
    //  //vAxis: { title: 'Rate' },
    //  hAxis: { title: 'Year' },
    //  seriesType: 'bars',
    //  series: { 5: { type: 'line' } },
    //  legend: { position: 'bottom' },
    //};

    //var chart = new google.visualization.ComboChart(document.getElementById('chart_welformedChart'));
    //chart.draw(data, options);

  }
  public RoundNum(num, length): number {
    
    var number = Math.round(num * Math.pow(10, length)) / Math.pow(10, length);
    return number;
  }

  onDbClicked(ev, es) {
    this.isSingleClick = false;
    let rdata = this.angularGrid.gridService.getDataItemByRowIndex(es.row)
    if (rdata != null && rdata != undefined) {
      this.yearUno = this.yearUno ? this.yearUno : 0;
      this.quarterUno = this.quarterUno ? this.quarterUno : 0;
      this.divisionUno = this.divisionUno ? this.divisionUno : 0;
      
      localStorage.removeItem('SlaPeformanceFilter');
      localStorage.setItem('SlaPeformanceFilter', '{"yearUno":"' + this.yearUno + '","quarterUno":"' + this.quarterUno + '","divisionUno":"' + this.divisionUno + '"}');

      this.router.navigate(['/dashboard-slaperformance-view/' + rdata.slaUno], { queryParams: { yearsla: this.yearUno, quatersla: this.quarterUno, divisionsla: this.divisionUno } });
    }
    return false;
  }
  getChartTypeData() {
    if (this.tenantUno > 1) {
      this.chartType_data = [
        { value: 'Quarter', text: 'Quarter' },
        { value: 'Year', text: 'Year' },
        { value: 'Month', text: 'Month' }
      ];
    }
    else {
      this.chartType_data = [
        { value: 'Quarter', text: 'Quarter' },
        { value: 'Year', text: 'Year' }
      ];
    }
  }

  AttachmentDownload(id: any, name: string) {
    let inpValue = new filecontent();
    inpValue.masterUNo = this.selectedSLAUno;
    inpValue.itemUNo = id;
    inpValue.userUno = this.login_UserID;
    this.spinner.show();
    this.restApi.SLA_Filedownload(inpValue).subscribe(
      data => {
        
        this.spinner.hide();
        if (data != null) {
          
          if (window.navigator.msSaveOrOpenBlob) //IE & Edge
          {
            //msSaveBlob only available for IE & Edge
            window.navigator.msSaveBlob(data, name);
          }
          else //Chrome & FF
          {
            var url = window.URL.createObjectURL(data);
            var a = document.createElement('a');
            document.body.appendChild(a);
            a.setAttribute('style', 'display: none');
            a.href = url;
            a.download = name;
            a.click();
            window.URL.revokeObjectURL(url);
            a.remove(); // remove the element
          }

        }
        else {
          this.spinner.hide();
          //Swal.fire('Error', 'Something went wrong', 'error');
          this.toaster.show('error', 'Error', 'Something went wrong.');
        }
      },
      error => {
        //Swal.fire('Error', 'Something went wrong', 'error')
        this.toaster.show('error', 'Error', 'Something went wrong.');
        this.spinner.hide();
      },
      () => {
        // 'onCompleted' callback.
        this.spinner.hide();

      }
    );

  }

  getFileIconClass(fileTitle: string) {

    if (fileTitle == '' || fileTitle == null)
      return "fa fa-file";

    var rtnClass = "fa fa-file";
    var strTitle = (fileTitle.indexOf('.') > 0) ? fileTitle.split('.')[1].toLowerCase() : 'unknown';

    switch (strTitle) {
      case 'txt':
        rtnClass = "fa fa-file-o";
        break;
      case 'doc':
        rtnClass = "fa fa-file-word-o";
        break;
      case 'docx':
        rtnClass = "fa fa-file-word-o";
        break;
      case 'xls':
        rtnClass = "fa fa-file-excel-o";
        break;
      case 'xlsx':
        rtnClass = "fa fa-file-excel-o";
        break;
      case 'pdf':
        rtnClass = "fa fa-file-pdf-o";
        break;
      case 'gif':
      case 'jpeg':
      case 'jpg':
      case 'png':
        rtnClass = "fa fa-file-picture-o";
        break;
      case 'mp3':
        rtnClass = "fa fa-file-audio-o";
        break;
      case 'mp4':
      case 'mpeg':
      case 'mpg':
      case 'avi':
        rtnClass = "fa fa-file-video-o";
        break;
      default:
        rtnClass = "fa fa-file";
        break;
    }

    return rtnClass;

  }

  onClick(e, es) {
    
    this.isSingleClick = true;
    // e.srcElement.className = "active";
    //let objitem = this.angularGrid.gridService.getDataItemByRowIndex(es.row);
    if (this.isSingleClick) {
      this.highlighSelectedRow(es.row);
    }
  }


  highlighSelectedRow(SelIndex) {

    this.angularGrid.gridService.highlightRow(this.g_previousIndex, 10);
    let that = this;
    this.angularGrid.gridService.highlightRow(SelIndex, 100000);
    setTimeout(function () {
      that.angularGrid.gridService.highlightRow(SelIndex, 100000);
    }, 300);

    this.g_previousIndex = SelIndex;
  }
  getTenantInfo() {
    this.spinner.show();
    let inpValue = new tenant();
    inpValue.languageUno = 1033;
    inpValue.itemUno = this.tenantUno;
    inpValue.condition = 2;
    inpValue.userUno = this.login_UserID;//this.RASHelper.encryptWithPublicKey('1');

    
    this.adminService.getTenants(inpValue)
      .subscribe(data => {
        

        let tenantData: any = data;
        if (tenantData != null && tenantData.length > 0) {
          this.isDivision = tenantData[0].isDivision;

        }
      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        this.spinner.hide();
      });
  }
}


